import Dict, { basicTypes, Schema } from "@togglecorp/ravl";

import dashboardSchemas from "./dashboard";
import commonSchemas from "./common";
import incidentSchemas from "./incident";
import realtimeSchemas from "./realtime";
import responseSchemas from "./response";

const userDefinedSchemas: Schema[] = [
  {
    doc: {
      name: "dbentity",
      description: "Defines all the attributes common to db entities",
    },
    fields: {
      id: { type: "uint", required: true },
      createdOn: { type: "string", required: true }, // date
      modifiedOn: { type: "string" }, // date
    },
  },
];

// const warning = !isProduction;
const warning = false;

const dict = new Dict({ warning });

const getSchemaName = (schema: Schema) => {
  const namedSchema = schema as Schema & {
    name?: string;
    doc?: {
      name?: string;
    };
  };

  return namedSchema.doc?.name ?? namedSchema.name;
};

[
  ...basicTypes,
  ...userDefinedSchemas,
  ...dashboardSchemas,
  ...commonSchemas,
  ...incidentSchemas,
  ...realtimeSchemas,
  ...responseSchemas,
]?.forEach((schema) => {
  const schemaName = getSchemaName(schema);
  if (schemaName) {
    dict.put(schemaName, schema);
  }
});

export default dict;
